import TagList from './TagList';
import { assetUrl } from '#/utils/assetUrl';

interface PageHeaderProps {
  tags: string[];
  title: string;
  date: string;
  profileImage?: string;
  profileName: string;
  disclaimer?: string;
}

export default function PageHeader({
  tags,
  title,
  date,
  profileImage,
  profileName,
  disclaimer,
}: PageHeaderProps) {
  return (
    <div className="flex w-full flex-col gap-6 px-6 pb-8 pt-8">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-3">
          <TagList tags={tags} />
          <div className="flex flex-col gap-1">
            <h1 className="whitespace-pre-line text-[28px] font-bold leading-[1.4] text-gray-100">
              {title}
            </h1>
            <p className="text-sm font-normal leading-[1.5] text-gray-50">
              {date}
            </p>
          </div>
        </div>
        <div className="flex w-full flex-col gap-1.5">
          <div className="flex w-full items-center gap-2 overflow-hidden rounded-xl">
            <div className="relative h-[42px] w-[42px] shrink-0 overflow-hidden rounded-xl">
              {profileImage ? (
                <img
                  src={profileImage}
                  alt={profileName}
                  className="h-full w-full object-cover"
                />
              ) : (
                <img
                  src={assetUrl('/logo-33.svg')}
                  alt="3.3"
                  className="h-full w-full"
                />
              )}
            </div>
            <span className="text-base font-bold leading-[1.5] text-gray-80">
              {profileName}
            </span>
          </div>
          {disclaimer && (
            <p className="text-[12px] font-normal leading-[1.5] text-gray-50">
              {disclaimer}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
